import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProviderWrapper } from './context/auth.context';
import { CssBaseline, ThemeProvider } from '@mui/material';
import getdojoTheme from './theme/getdojoTheme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={getdojoTheme}>
      <CssBaseline />
      <AuthProviderWrapper>
        <App />
      </AuthProviderWrapper>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
